import React from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumb } from "react-bootstrap";

export default function BreadcrumbList({ list }) {


  return (
    <Breadcrumb>
      {list.map((item, index, { length }) => {

        if (index + 1 === length) return (
          <Breadcrumb.Item key={index} aria-current="page" active>
            {item.label}
          </Breadcrumb.Item>
        );

        return (
          <Breadcrumb.Item key={index} href="#" onClick={(e) => e.preventDefault()}>
            <Link to={item.to}>
              {item.label}
            </Link>
          </Breadcrumb.Item>
        );
      })}
    </Breadcrumb>
  );
}